const CrosstabDisplayType = Object.freeze({
  VALUE: 'VALUE',
  PERCENT_SHARE: 'PERCENT_SHARE'
})
export default CrosstabDisplayType
export type CrosstabDisplayTypeStrings = typeof CrosstabDisplayType[keyof typeof CrosstabDisplayType]
// RESERVE BELOW
